export default function DaytonaHeroSection() {
  return (
    <section className="relative pt-32 pb-28 md:pt-40 md:pb-36 bg-[#1A365D] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#1A365D] via-[#1A365D] to-[#0F2240]"></div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
        <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Daytona Beach, FL</p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Emergency Passport<br/>Daytona Beach, Florida
        </h1>
        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto mb-8 leading-relaxed">
          Expedited passport services as fast as 2–3 business days. A+ BBB rated, registered U.S. Department of State passport courier serving Daytona Beach, Volusia County, and Central Florida coastal travelers.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
          <a href="tel:8772530084" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap border border-white/20">
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}